import { isBefore } from 'date-fns/isBefore';
import { isSameDay } from 'date-fns/isSameDay';
import { parseISO } from 'date-fns/parseISO';
import {
  type ValidatorFunction,
  type ValidatorResult,
} from 'ember-changeset-validations';
import { utcDate } from 'uplisting-frontend/utils/date';
import { getIntl } from 'uplisting-frontend/validators/-internal';

export function validateIsBefore(fieldName: string): ValidatorFunction {
  return (
    key: string,
    newValue: unknown,
    _oldValue: unknown,
    changes: Record<string, unknown>,
    content: Record<string, unknown>,
  ): ValidatorResult => {
    const other = changes[fieldName] ?? content[fieldName];

    const startAligned =
      newValue instanceof Date
        ? utcDate(newValue)
        : parseISO(newValue as string);

    const endAligned =
      other instanceof Date
        ? utcDate(other ?? new Date())
        : parseISO(other as string);

    const isValid =
      isBefore(startAligned, endAligned) &&
      !isSameDay(startAligned, endAligned);

    if (!isValid) {
      return getIntl().t(`validation_messages.custom.is_before_${key}`);
    }

    return true;
  };
}
